import type { Routes } from '@angular/router';
import { RegistrationFormService } from './views/sign-up/services/registration-form/registration-form.service';
import { PageTitles } from '@app/domain/enums';
import { authGuard } from '@app/routing/guards/auth.guard';
import { guestGuard } from '@app/routing/guards/guest.guard';
import { locationGuard } from '@app/routing/guards/location.guard';
import { loginEmailGuard } from '@app/routing/guards/login-email.guard';
import { PrivateView } from '@app/views/private/private.view';
import { SignUpView } from '@app/views/sign-up/sign-up.view';

export const routes: Routes = [
  {
    path: 'welcome',
    canActivate: [guestGuard],
    loadComponent: () => import('./views/welcome/welcome.view').then(component => component.WelcomeView),
    title: PageTitles.WELCOME,
  },
  {
    path: 'login',
    canActivate: [guestGuard, loginEmailGuard],
    loadComponent: () => import('./views/login/login.view').then(component => component.LoginView),
    title: PageTitles.LOGIN,
  },
  {
    path: 'remind-password',
    loadChildren: () => import('./views/remind-password/remind-password.routes'),
    canActivate: [guestGuard],
  },
  {
    path: 'sign-up',
    component: SignUpView,
    title: PageTitles.REGISTRATION,
    canActivate: [guestGuard],
    providers: [RegistrationFormService],
    loadChildren: () => import('./views/sign-up/sign-up.routes'),
  },
  {
    path: '',
    component: PrivateView,
    canActivate: [authGuard, locationGuard],
    loadChildren: () => import('./views/private/private.routes'),
  },
  {
    path: '**',
    loadComponent: () => import('./views/not-found/not-found.view').then(component => component.NotFoundView),
  },
];
